export const fieldLabels: Record<string, string> = {
  name: 'Name',
  friendlyPracticeName: 'Friendly Practice Name',
  athenaScheduleName: 'Athena Schedule Name',
  address1: 'Street Address',
  address2: 'Street Address 2',
  city: 'City',
  state: 'State',
  zip: 'Zipcode',
  Directions: 'Directions',
  market: 'Market',
  'Group-TID': 'Tax ID',
  timezone: 'Timezone',
  fluShots: 'Flu Shot Availability',
  'Screen-For-Covid-When-Scheduling':
    'Screen for Covid When Scheduling',
  Phone: 'Phone Number',
  Fax: 'Fax Line',
  Backline: 'Back Line',
  'After-Hours': 'After Hours Line',
  managerPhone: 'Escalation Line',
  'Manager-Line': 'Escalation Line',
  managerName: 'Manager Name',
  managerEmail: 'Manager Email',
  'Clinical-Staff': 'Clinical Staff',
  'Front-Staff': 'Front Staff',
  Director: 'Director',
  Holidays: 'Holidays',
  'Next-In-Line': 'Next in Line',
  'Labs-Drawn-Hours': 'Labs Hours',
  'Imaging-Available-Hours': 'Imaging Hours',
  'Clinic NPI': 'Clinic NPI',
  'Manager-Name': 'Manager Name',
  'Manager-Email': 'Manager Email',
  'Manager-Phone': 'Manager Phone',
  'Cerner-location': 'Cerner Encounter Location',
  'Cerner-pool': 'Cerner Pool',
  'Cerner-Hub': 'Cerner Hub',
  'Type-Of-Schedule': 'Type Of Schedule',
  Ekg: 'Ekg',
  'Flu-Shots': 'Flu Shots',
  'Medical-Records-Number': 'Medical Records Number',
};

export const requiredFields = Object.keys(fieldLabels);
